import ManagedCampaignCreatePage from "./ManagedCampaignCreatePage";

export default ManagedCampaignCreatePage;
